export const projects = [
  {
    slug: 'within-pilates',
    name: '위드인 필라테스',
    image: 'https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/e0306daf8d057e1055e8e12f8ed6e2a3.jpeg',
    location: '춘천, 대한민국',
    year: '2024',
    size: '45㎡',
    description: '현대적이고 세련된 필라테스 스튜디오 인테리어 디자인'
  },
  {
    slug: 'hoon-kimchi-jjim',
    name: '훈이네 김치찜',
    image: 'https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/0eebf1ae6a6a8140648b44b9d070d508.jpeg',
    location: '춘천, 대한민국',
    year: '2025',
    size: '89㎡',
    description: '따뜻하고 아늑한 분위기의 한식당 인테리어'
  },
  {
    slug: 'first-button-english',
    name: '첫단추 영어 학원',
    image: 'https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/f48031c028058f3374b68643eb27e35f.jpeg',
    location: '춘천, 대한민국',
    year: '2025',
    size: '103㎡',
    description: '밝고 창의적인 학습 공간 디자인'
  },
  {
    slug: 'sagori-raw-fish',
    name: '사거리 횟집',
    image: 'https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/634714be59b76eea2e368400870a00b8.jpeg',
    location: '춘천, 대한민국',
    year: '2025',
    size: '94㎡',
    description: '신선함과 청결함을 강조한 횟집 인테리어'
  },
  {
    slug: 'hongcheon-hyundai-apt',
    name: '홍천 현대아파트',
    image: 'https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/84d270a32c02cd737c193eb5f79e469b.jpeg',
    location: '홍천, 대한민국',
    year: '2024',
    size: '80㎡',
    description: '모던하고 실용적인 아파트 인테리어'
  },
  {
    slug: 'happygreen',
    name: 'happygreen',
    image: 'https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/e48adfe26c29ed45afc70aaae8b51c0a.jpeg',
    location: '남양주, 대한민국',
    year: '2024',
    size: '85㎡',
    description: '자연 친화적이고 편안한 공간 디자인'
  },
  {
    slug: 'hyungje-pizza',
    name: '형제피자',
    image: 'https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/b2483e2f51e60c5c10f796d244e079a3.jpeg',
    location: '서울, 대한민국',
    year: '2024',
    size: '51㎡',
    description: '활기차고 모던한 피자 레스토랑 인테리어'
  },
  {
    slug: 'eodam',
    name: '어담',
    image: 'https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/bcf5b8d747f4c649f6d36e98fd543ef4.jpeg',
    location: '춘천, 대한민국',
    year: '2026',
    size: '115㎡',
    description: '세련되고 고급스러운 상업 공간 디자인'
  },
  {
    slug: 'project-9',
    name: '일과 사랑',
    image: 'https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/915056ef1044039ba0580cbbdd1a1a5a.jpeg',
    location: '춘천, 대한민국',
    year: '2024',
    size: '68㎡',
    description: '따뜻한 분위기의 카페 인테리어 디자인'
  },
  {
    slug: 'project-10',
    name: 'Base Camp',
    image: 'https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/4e5078eabdd8a57290d2eab26d26b9be.jpeg',
    location: '춘천, 대한민국',
    year: '2023',
    size: '80㎡',
    description: '모던하고 감각적인 카페 인테리어 디자인'
  },
  {
    slug: 'project-11',
    name: '한신 휴플러스 아파트',
    image: 'https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/a036f21f399a307806369d846ef5892c.jpeg',
    location: '춘천, 대한민국',
    year: '2025',
    size: '89㎡',
    description: '깔끔하고 편안한 치과 인테리어 디자인'
  },
  {
    slug: 'project-12',
    name: '이안아파트',
    image: 'https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/5301f66bb57b80536465becb9ef853d2.jpeg',
    location: '춘천, 대한민국',
    year: '2026',
    size: '85㎡',
    description: '감각적인 의류 매장 인테리어 디자인'
  }
];